




























import Vue from "vue";
import { SharedState } from "@/common/state/index";
import { computed, ref } from "@vue/composition-api";
import { isEmail } from "@/utils/validate";
import { AppAnalytics } from "@/analytics";
import { UseToast, ToastType } from "./toast/toast.state";
export default Vue.extend({
  setup() {
    const { env, loggedUser } = SharedState;

    const onboardingLink = computed(
      () => env.value.onboarding + "?from=surveil"
    );
    const reload = () => window.location.reload();

    const email = ref("");
    const prevEmail = ref("");
    const isValidEmail = computed(() => {
      const isValidPattern = isEmail(email.value);
      return isValidPattern;
    });

    const isEmailChanged = computed(() => prevEmail.value !== email.value);

    const disableSubmit = computed(
      () => !isEmailChanged.value || !isValidEmail.value
    );

    const submitEmail = () => {
      if (isValidEmail.value && isEmailChanged.value) {
        AppAnalytics.report({
          component: "General",
          eventName: "Thats it:user submit email",
          payload: {
            email: email.value,
          },
        });
        prevEmail.value = email.value;
        UseToast().show({
          type: ToastType.SUCCESS,
          msg:
            "Great! <br> We'll let you know when your dashboard is up and running",
          duration: 5000,
        });
      }
    };

    return {
      reload,
      onboardingLink,
      loggedUser,
      submitEmail,
      email,
      disableSubmit,
    };
  },
});
